import { useContext } from 'react';

import { ContextType } from '@/@generated/codegen/API';
import { CurrentMeetingDataContext } from '@/features/meeting/context/CurrentMeetingDataContext';

type UseContextTypeReturn = {
  contextType: ContextType;
  objId: string;
};

export const useContextType = (): UseContextTypeReturn => {
  const meetingContext = useContext(CurrentMeetingDataContext);
  // if (meetingContext && masterClassContext) {
  //   throw new Error(
  //     'useContextType error: There should not be multiple context providers (eg: meeting and masterclass) at the same time'
  //   );
  // }
  if (meetingContext && meetingContext.status === 'in-meeting') {
    return {
      contextType: ContextType.Meeting,
      objId: meetingContext.currentMeetingId,
    };
  }

  throw new Error(
    'useContextType must be used within a context provider (eg: meeting or masterclass) and there should be a session such as meetingId or masterClassId'
  );
};
